import { get, post } from './request';
export const userTest =  data => get('/user/test', data  );

export const postSMSforLogin = data => post('/sm/user/login/send/code', data  );
export const postCodeforLogin = data => post('/sm/user/login/code/check', data  );
export const getNftList = data => post('/nft/index', data  );
export const getNftSign = data => post('/nft/sign', data  );













